import React from 'react';
import { Container } from '@mui/material';
import { Switch, useRouteMatch, Route, useParams } from 'react-router-dom';
import BundleBrowseView from './BundleBrowseView';
import BundleDetailView from './BundleDetailView';
import {BundleProvider} from './BundleContext';
import { TagsContextProvider } from 'Modules/Components/TagsContext';

export default function BundlesModule() {
    const { path } = useRouteMatch();

    return (
        <BundleProvider>
            <TagsContextProvider>
            <Container maxWidth="xl" sx={{ overflowY: 'hidden', display: 'flex', height: '100vh', justifyContent: 'stretch'}}>
                <Switch>
                    <Route exact path={path}> <BundleBrowseView /></Route>
                    <Route path={`${path}/:bundleId`}> <DetailRoute /> </Route>
                </Switch>
            </Container>
            </TagsContextProvider>
        </BundleProvider>
    )
}

function DetailRoute() {
    const { bundleId } = useParams();
    return (<BundleDetailView bundleId={bundleId} />);
}
